module.exports = __webpack_public_path__ + "static/media/Servicenow-logo.9be3f3cf.png";